export { buildClassMap } from './buildClassMap';

export {
  IIconRecord,
  IIconSubset,
  IIconOptions,
  getIcon,
  registerIcons,
  registerIconAlias,
  unregisterIcons,
  setIconOptions
} from './icons';

export { getIconClassName } from './getIconClassName';
